// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"251":"0e460bd4","334":"a9a00a59","677":"0cf1ed92","681":"a9a00a59"}[chunkId] + ".chunk.css";
};